import * as React from 'react'

import Paper from '@material-ui/core/Paper'

import { Login } from '../organisms'

export default () => (
  <Paper>
    <Login />
  </Paper>
)



// WEBPACK FOOTER //
// ./src/components/environments/LoginArea.tsx